import { Editor, Text, Transforms } from 'slate';
import { v4 as uuid } from 'uuid';

// models
import {
    EditorType,
    ElementKind,
    VariantElement,
} from '../../../models/editor.model';

const variantMethods = {
    isText(editor: EditorType) {
        const [match] = Editor.nodes(editor, {
            match: (node) => !Editor.isEditor(node) && Text.isText(node),
        });
        return !!match;
    },
    isVariant(editor: EditorType) {
        const [match] = Editor.nodes(editor, {
            match: (node) =>
                !Editor.isEditor(node) &&
                !Text.isText(node) &&
                node.kind === ElementKind.variant,
        });
        return !!match;
    },
    isDataset(editor: EditorType) {
        const [match] = Editor.nodes(editor, {
            match: (node) =>
                !Editor.isEditor(node) &&
                !Text.isText(node) &&
                node.kind === ElementKind.dataset,
        });
        return !!match;
    },
    toggleVariant(
        editor: EditorType,
        variantType: string,
        componentId?: string,
    ): void {
        if (editor.selection && variantMethods.isText(editor)) {
            const text = Editor.string(editor, editor.selection);
            if (text.length) {
                // Create the variant in the editor
                const variantElement: VariantElement = {
                    kind: ElementKind.variant,
                    variantType,
                    children: [],
                    id: uuid(),
                    componentId,
                };
                Transforms.wrapNodes(editor, variantElement, { split: true });

                Transforms.deselect(editor);
            } else {
                alert('Select some text to create a component');
            }
        }
    },
};

export default variantMethods;
